import React, { useEffect, useState } from 'react';
import './ThemeToggle.css';

type Theme = 'light' | 'dark';

function initialTheme(): Theme {
  const saved = localStorage.getItem('recibos-theme');
  if (saved === 'light' || saved === 'dark') return saved;
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

export default function ThemeToggle(): React.ReactElement {
  const [theme, setTheme] = useState<Theme>(initialTheme);
  useEffect(() => { document.documentElement.dataset.theme = theme; document.documentElement.style.colorScheme = theme; localStorage.setItem('recibos-theme', theme); }, [theme]);
  const dark = theme === 'dark';
  return <button className="theme-toggle" type="button" onClick={() => setTheme(dark ? 'light' : 'dark')} aria-label={dark ? 'Activar modo claro' : 'Activar modo oscuro'} title={dark ? 'Modo claro' : 'Modo oscuro'}><span className="theme-toggle-icon" aria-hidden="true">{dark ? '☀' : '☾'}</span><span>{dark ? 'Claro' : 'Oscuro'}</span></button>;
}
